import type { Card } from '../../types';

export const TOXIC_DART: Card = {
  id: 'toxic-dart',
  name: 'Toxic Dart',
  type: 'support',
  rarity: 'common',
  size: { w: 1, h: 1 },
  cost: [{ kind: 'min', value: 3 }],
  effects: [
    {
      kind: 'applyStatus',
      application: { status: 'poison', magnitude: 3, duration: 1, target: 'opponent' },
    },
  ],
};
